import "@fontsource/heebo/300.css";
import "@fontsource/heebo/700.css";
import 'swiper/swiper.min.css';
import 'swiper/swiper-bundle.min.css';
import Swiper, { Navigation, Pagination, Autoplay, EffectFade , Thumbs, Grid } from 'swiper';


Swiper.use([Navigation, Pagination, Autoplay, EffectFade, Thumbs, Grid]);
window.Swiper = Swiper;

// JavaScript
$(document).ready( function () {
  //scroll top
  $('.back-to-top').click(function(event){
    $("html,body").animate({scrollTop: 0}, 1000);
  });

  if ($('.show-in-left').length) {
    gsap.set(".show-in-left", { opacity: 0, x: -40 });
    ScrollTrigger.batch(".show-in-left", {
      onEnter: function onEnter(batch) {
        gsap.to(batch, { ease: 'back.out(1.5)', opacity: 1, x: 0, stagger: 0.3 });
      },
    });
  }
  // transparent header
  let $header_h = $('.header').outerHeight();
  if ($(window).scrollTop() > $header_h) {
    $('.header').addClass("min-header");
  } else {
    $('.header').removeClass("min-header");
  }
  $(window).on('scroll', function () {
    if ($(window).scrollTop() > $header_h) {
      $('.header').addClass("min-header");
    } else {
      $('.header').removeClass("min-header");
    }
  });

  $('.header-mobile-menu').on('click', function () {
    if ($(this).hasClass('active')) {
      $(this).removeClass('active');
      $('.header-menu-outer').addClass('hidden');
      setTimeout(() => {
        $('.header-menu-outer').removeClass('active hidden');
      }, 350);
    }else {
      $(this).addClass('active');
      $('.header-menu-outer').addClass('active');
    }
  });

  // header dropdown
  $('.menu-dropdown-toggle').on('click', function() {
    $(this).parents('.header-menu-link.dropdown').toggleClass('active');
  })

  var indexSlider = new Swiper('#indexSlider', {
    effect: 'fade',
    autoplay: {
      delay: 5000,
    },
    loop: true,
    speed: 1000,
    navigation: {
      nextEl: '.swiper-button-next-custom',
      prevEl: '.swiper-button-prev-custom'
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true
    },
  });

  // table responsive
  if ($('.custom-editor table').length >= 1) {
    $('.custom-editor table').wrap('<div class="table-responsive"/></div>');
  }

  // tab
  $('.tab[data-tab]').on('click', function () {
    var tabPanes = $(this).data('tabs');
    var ID = $(this).data('tab');
    $(this).addClass('is-active').siblings().removeClass('is-active');
    $("[data-tab-panes=" + tabPanes + "]").find("[data-tab-pane=" + ID + "]").addClass('is-active').siblings().removeClass('is-active');
  });


  // about partners
  let partnersSlider = null;

  // 初始化或重建 Swiper
  function initPartnersSlider() {
    const swiperWrapper = document.querySelector('#partnersSlider .swiper-wrapper');
    const slides = swiperWrapper.querySelectorAll('.swiper-slide:not(.is-empty)');
    const totalSlides = slides.length;

    // 根據螢幕寬度判斷每頁要多少個項目
    const perView = window.innerWidth >= 801 ? 5 : 3; // 欄數
    const rows = window.innerWidth >= 801 ? 5 : 8;  // 列數
    const perPage = perView * rows;

    // 清除舊的空白 slide
    swiperWrapper.querySelectorAll('.is-empty').forEach(e => e.remove());
    // 插入空白 slide，防止 Swiper grid 對不足一頁的項目自動填充導致順序錯亂
    const remainder = totalSlides % perPage;
    const emptyCount = remainder === 0 ? 0 : perPage - remainder;
    for (let i = 0; i < emptyCount; i++) {
      const emptySlide = document.createElement('div');
      emptySlide.className = 'swiper-slide is-empty';
      swiperWrapper.appendChild(emptySlide);
    }

    // 如果已有 Swiper 實例，銷毀重建
    if (partnersSlider) partnersSlider.destroy(true, true);

    // 初始化 swiper
    partnersSlider = new Swiper('#partnersSlider', {    
      slidesPerView: perView,  // 每列 n 張圖
      grid: {
        rows: rows,  // 每頁 n 列
        fill: 'row',  // 橫向填滿
      },
      slidesPerGroup: perView, // 一次切換 1 整頁（=n列）
      spaceBetween: 0,  // 圖片之間間距
      loop: false,  // 禁止循環，不然會錯亂
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      // 根據螢幕大小調整排版 (min-width)
      breakpoints: {
        801: { slidesPerView: 5, grid: { rows: 5, fill: 'row' }, slidesPerGroup: 5 },
        0: { slidesPerView: 3, grid: { rows: 8, fill: 'row' }, slidesPerGroup: 3 },
      },
    });
  }
  // 如果頁面上有 partnersSlider
  if ($('#partnersSlider').length > 0) {
    initPartnersSlider(); // 初始載入 swiper
  }
  // resize 時自動重建
  let currentMode = window.innerWidth >= 801 ? 'desktop' : 'mobile';
  let aboutResizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(aboutResizeTimer);
    aboutResizeTimer = setTimeout(function() {
      let newMode = window.innerWidth >= 801 ? 'desktop' : 'mobile';
      // 只有模式切換時才重建
      if (newMode !== currentMode) {
        // 如果頁面上有 partnersSlider
        if ($('#partnersSlider').length > 0) {
          initPartnersSlider(); // 重建 Swiper
        }
        currentMode = newMode;
      }
    }, 300);
  });


  // cases filter collapse
  const $collapse_btn = $('#js-showcase-collapse-toggle-btn');
  const $collapse_content = $('#js-showcase-collapse-content');
  $collapse_btn.on('click', function() {
    // 要關閉
    if ( $collapse_content.hasClass('show') ) {
      $collapse_btn.removeClass('active');
      $collapse_content.removeClass('show');
      $collapse_content.css('height', '0px');
    // 要開啟
    } else {
      $collapse_btn.addClass('active');
      $collapse_content.addClass('show');
      $collapse_content.css('height', $collapse_content[0].scrollHeight + 'px');
    }
  });
  let casesResizeTimer; // resize計時器
  $(window).on('resize', function() {
    clearTimeout(casesResizeTimer);
    casesResizeTimer = setTimeout(function () {
      // 如果目前 collapse content 開著, 就重新設定高度
      if ( $collapse_content.hasClass('show') ) {
        $collapse_content.css('height', 'auto');  // 先將高度設定為auto, 不然無法重新抓到正確高度
        requestAnimationFrame(() => {
          $collapse_content.css('height', $collapse_content[0].scrollHeight + 'px'); // 重新取得高度
        });
      }
    }, 200);
  });

  // showcase
  var showcaseSlider = new Swiper('#showcaseSlider', {
    effect: 'fade',
    autoplay: {
      delay: 6000,
    },
    speed: 1500,
    loop: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });


  // news slider bg
  const $newsSliderBG = $('#js-news-swiper-bg');
  function updateBackground(swiper) {
    const activeSlide = swiper.slides[swiper.activeIndex];
    const imgEl = activeSlide.querySelector('.image-wrap img');
    const bgUrl = imgEl ? imgEl.src : $newsSliderBG.attr('data-bg');
    $newsSliderBG.css('background-image', `url(${bgUrl})`);
  }

  // news
  const newsSlider = new Swiper('#newsSlider', {
    loop: false,
    on: {
      init: function() {
        updateBackground(this);
      },
      slideChange: function() {
        updateBackground(this);
      }
    },

    // If we need pagination
    pagination: {
      el: '.swiper-pagination',
    },

    // Navigation arrows
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });

  // news inner
  const $postSidemenu = $('.js-post-sidemenu');
  const $postWrap = $('.post-inner-wrapper');
  const $post_h2_list = $postWrap.find('h2:not(".related-title")');
  let post_h2_data = []; // h2 區塊的資訊
  function updatePostH2Data() {
    post_h2_data = [];
    $post_h2_list.each(function(index, h2) {
      $(h2).attr('id', `h2-${index}`);
      post_h2_data.push({
        id: `h2-${index}`,
        offsetTop: $(h2).offset().top - 30
      })
    });
  }
  if ( $post_h2_list.length != 0 ) {
    // set h2
    updatePostH2Data();
    // set sidemenu
    $postSidemenu.each(function(i, sidemenu) {
      let $postSidemenuContent = $(sidemenu).find('.post-sidemenu-content'); // 內容容器
      $postSidemenuContent.append('<ul></ul>');
      // set link anchor
      $post_h2_list.each(function(index, el) {
        $postSidemenuContent.find('ul').append(`<li class="sidemenu-item" data-id="h2-${index}"><a href="#h2-${index}">${$(el).text()}</a></li>`);
        $postSidemenuContent.find(`[href="#h2-${index}"]`).on('click', function() {
          $("html,body").animate({scrollTop: $(el).offset().top - 30}, 500);
        });
      });
    })
  }
  $(window).on('scroll', function () {
    // 如果頁面上有 postSidemenu
    if ($postSidemenu.length != 0) {
      let scrolled = $(window).scrollTop();
      $('.sidemenu-item').removeClass('active');
      // 判斷目前在哪個 h2 標籤下
      for (const d of post_h2_data) {
        if ( scrolled >= d.offsetTop ) {
          $('.sidemenu-item').removeClass('active');
          $(`[data-id="${d.id}"`).addClass('active');
        }
      }
    }
  });
  let sidemenuResizeTimer; // resize計時器
  $(window).on('resize', function() {
    clearTimeout(sidemenuResizeTimer);
    sidemenuResizeTimer = setTimeout(function () {
      // 如果頁面上有 postSidemenu
      if ($postSidemenu.length != 0) {
        updatePostH2Data()
      }
    }, 200);
  });

  // faq
  $('.js-faq-accordion .faq-item-collapse').hide();
  $('.js-faq-accordion .faq-item-toggle').on('click', function() {
    $(this).parents('.faq-item').toggleClass('active');
    $(this).siblings('.faq-item-collapse').slideToggle(200);
  });

  // service showcase slides
  const serviceShowcaseSlider = new Swiper('#serviceShowcaseSlider', {
    loop: true,
    pagination: {
      el: '.swiper-pagination',
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });

});

window.addEventListener("load", () => {
  let urlHash = window.location.href.split("#")[1],
    scrollElem = document.querySelector("#" + urlHash);
  if (scrollElem) {
    gsap.to(window, { scrollTo: scrollElem });
  }
});
